'use client';

import { c as _c } from "react/compiler-runtime";
import { preload } from 'react-dom';
import { FleetCategoryComparisonCard } from '@/components/FleetCategory/FleetCategoryComparisonCard';
import { Link } from '@/components/Link';
import { Typography } from '@/components/Typography';
import { CarouselSlide } from '@/components/carousel/CarouselSlide';
import { ComparisonCarousel } from './ComparisonCarousel';
import { useVehicleCompareState } from './VehicleCompareContext';
import addVehicleDefault from './add_vehicle_default.png';
export function Comparison() {
  const $ = _c(13);
  const {
    categories,
    categoryCount,
    vlpUrl
  } = useVehicleCompareState();
  let t0;
  if ($[0] !== vlpUrl) {
    t0 = vlpUrl.split("/");
    $[0] = vlpUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const urlParts = t0;
  const categoryName = urlParts[urlParts.length - 1];
  preload(addVehicleDefault.src, {
    as: "image"
  });
  let t1;
  if ($[2] !== categories || $[3] !== categoryCount || $[4] !== categoryName || $[5] !== vlpUrl) {
    let t2;
    if ($[7] !== categoryCount || $[8] !== categoryName || $[9] !== vlpUrl) {
      t2 = (category, index) => {
        const categoryKey = category ? `${category.code}-${category.region}` : "";
        const key = `sticky-list-${index}-${categoryKey}`;
        return <CarouselSlide as="div" className="rounded-2xl shadow-[0_4px_20px_0_rgba(0,0,0,0.15)] p-6 md:p-8 w-[87%] md:w-[30%]" key={key}>{category ? <FleetCategoryComparisonCard fleetCategory={category} /> : <article className="flex flex-col justify-center items-center h-full"><div className="w-35 h-35 bg-(image:--texture-url) bg-center bg-no-repeat bg-cover" style={{
              "--texture-url": `url(${addVehicleDefault.src})`
            }} /><Typography className="text-[24px] md:text-[32px] text-center leading-[51.2px]" as="div" variant="h3">{categoryCount === 0 ? "Add vehicles to compare" : "Add another vehicle"}</Typography><Link className="btn bg-white border-primary text-primary h-13 px-7.5 mt-8" href={vlpUrl}>View {categoryName}</Link></article>}</CarouselSlide>;
      };
      $[7] = categoryCount;
      $[8] = categoryName;
      $[9] = vlpUrl;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = categories.map(t2);
    $[2] = categories;
    $[3] = categoryCount;
    $[4] = categoryName;
    $[5] = vlpUrl;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <ComparisonCarousel>{t1}</ComparisonCarousel>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}